import React, { useEffect, useState } from "react";
import { BookOpen, ChevronDown } from "lucide-react";
import { api } from "@/lib/apiClient";

// OCTON Model Codex — every prediction-science method mapped to how OCTON implements it, with LIVE parameter values.
export const ModelCodexCard = () => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/model-codex").then((r) => setData(r.data)).catch(() => setData({ entries: [] })); }, []);
  // Voice: explain_method opens the matching entry here so what she says is what glows.
  useEffect(() => {
    const h = (e) => { const id = e?.detail?.id; if (id) { setOpen(id); setTimeout(() => document.querySelector(`[data-testid='codex-entry-${id}']`)?.scrollIntoView({ behavior: "smooth", block: "center" }), 50); } };
    window.addEventListener("octon:codex-open", h);
    return () => window.removeEventListener("octon:codex-open", h);
  }, []);
  const entries = data?.entries || [];
  return (
    <div className="card-tac mb-4 p-5" data-testid="model-codex-card"
      data-octon-section="model codex prediction science glossary methods poisson dixon coles negative binomial kalman hierarchical time decay ensemble brier calibration"
      data-octon-label="Model Codex" data-octon-state={data ? "ready" : "loading"}>
      <div className="flex items-center gap-2">
        <BookOpen size={16} className="txt-cyan" />
        <span className="font-tac text-[10px] tracking-widest text-white/60">MODEL CODEX · {entries.length} METHODS · LIVE PARAMETERS</span>
      </div>
      <p className="mt-2 text-[12px] text-white/50">Every method in OCTON's prediction science — the textbook meaning, exactly how OCTON implements it, and the parameter values it is running with right now.</p>
      <div className="mt-3 divide-y divide-white/8">
        {entries.map((e) => {
          const isOpen = open === e.id;
          return (
            <div key={e.id} data-testid={`codex-entry-${e.id}`}>
              <button onClick={() => setOpen(isOpen ? null : e.id)} data-testid={`codex-toggle-${e.id}`} aria-expanded={isOpen} aria-label={`${isOpen ? "Close" : "Open"} codex entry ${e.term}`}
                className="flex w-full items-center justify-between gap-3 py-2.5 text-left">
                <span className="text-sm text-white/90">{e.term}</span>
                <ChevronDown size={14} className={`shrink-0 text-white/40 transition-transform ${isOpen ? "rotate-180" : ""}`} />
              </button>
              {isOpen && (
                <div className="pb-4 text-[12px] leading-relaxed" data-testid={`codex-body-${e.id}`}
                  data-octon-section={`codex ${e.term} ${e.id.replace(/_/g, " ")}`} data-octon-label={`Codex · ${e.term}`} data-octon-state="ready">
                  <p className="text-white/55"><span className="font-tac text-[9px] tracking-widest text-white/35">GLOSSARY · </span>{e.glossary}</p>
                  <p className="mt-2 text-white/85"><span className="font-tac text-[9px] tracking-widest txt-cyan">OCTON · </span>{e.octon_implementation}</p>
                  {Object.keys(e.live_params || {}).length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-1.5">
                      {Object.entries(e.live_params).map(([k, v]) => (
                        <span key={k} className="rounded-md border border-cyan-400/25 bg-cyan-400/5 px-2 py-0.5 font-mono text-[10px] text-cyan-200" data-testid={`codex-param-${e.id}-${k}`}>
                          {k} = {typeof v === "object" ? JSON.stringify(v) : String(v)}
                        </span>
                      ))}
                    </div>
                  )}
                  <p className="mt-2 text-white/40"><span className="font-tac text-[9px] tracking-widest text-amber-300/70">LIMITS · </span>{e.limits}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
